import { Component, HostBinding, Input, ViewEncapsulation, } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'div[euiInputGroup]',
    styleUrls: ['./styles/_index.scss'],
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class EuiInputGroupComponent {

    @HostBinding('class')
    public get cssClasses(): any {
        return [
            'eui-input-group',
            this.styleClass ? this.styleClass : ''
        ].join(' ').trim();
    }

    @Input() styleClass: string;
    @HostBinding('attr.type') protected type: string = 'inputGroup';

    constructor() {
    }

}
